import React, { FC, useEffect, useRef, useState } from 'react';
import classnames from 'classnames';

import { fc } from 'i18n';

import styles from './styles.module.css';

interface IRemarksCellProps {
  remarks?: string;
}

export const RemarksCell: FC<IRemarksCellProps> = ({ remarks }) => {
  const ref = useRef<HTMLDivElement | null>(null);

  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const [withTruncation, setWithTruncation] = useState<boolean>(false);

  const remarksClassName = classnames(styles.remarks, { [styles.hidden]: !isExpanded });

  const toggleExpanded = () => setIsExpanded(!isExpanded);

  useEffect(() => {
    setWithTruncation(!!ref.current && ref.current.offsetWidth < ref.current.scrollWidth);
  }, []);

  return (
    <div className={styles.wrapper}>
      <span ref={ref} className={remarksClassName}>
        {remarks || '-'}
      </span>
      {!!remarks && withTruncation && (
        <span className={styles.more} onClick={toggleExpanded}>
          {fc(isExpanded ? 'show less' : 'show more')}
        </span>
      )}
    </div>
  );
};
